import styled, {css} from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import {SearchWrapper} from "Components/Search/hits";
import {Icon} from "../Icons/Svg";

const SubmitBase = styled.button.attrs(({
                                          ariaLabel,
                                          display,
                                          left,
                                          right,
                                          nomargin,
                                          margin,
                                          padding,
                                          wide,
                                          type,
                                          disabledcolor,
                                          scale,
                                          fullwidth,
                                          width,
                                          minWidth,
                                          widthsmall,
                                          heightsmall,
                                          border,
                                          borderradius,
                                          justifycontent,
                                          theme,
                                          lineHeight,
                                          importandPadding,
                                          transition = true,
                                          textTransform,
                                          opacity,
                                          alignself,
                                          mobileAlignself
                                        }) => ({
  "aria-label": ariaLabel || "submit button",
  display: display ? display : "inline-block",
  marginright: left ? "auto" : 0,
  marginleft: right ? "auto" : 0,
  margin: nomargin ? 0 : margin ? margin : `0.5rem ${left ? "auto" : 0} 0.5rem ${right ? "auto" : 0}`,
  padding: padding ? padding : wide ? "0.1rem 2rem" : "0.125rem 0",
  type: type ? type : "button",
  disabledcolor: disabledcolor ? disabledcolor : theme.colors.lightgrey,
  opacity: opacity ? opacity : 1,
  scale: scale ? scale : "1",
  width: fullwidth ? fullwidth : wide ? "auto" : width ? width : "180px",
  widthsmall: fullwidth ? fullwidth : wide ? "auto" : widthsmall ? widthsmall : "auto",
  heightsmall: heightsmall ? heightsmall : "",
  border: border,
  borderradius: borderradius,
  justifycontent: justifycontent ? justifycontent : "unset",
  minWidth: minWidth ? minWidth : "",
  lineHeight: lineHeight ? lineHeight : undefined,
  importandPadding: importandPadding,
  transition: transition ? "all 0.2s ease" : undefined,
  textTransform: textTransform ? textTransform : undefined,
  alignself: alignself ? alignself : undefined,
  mobileAlignself: mobileAlignself ? mobileAlignself : undefined
}))`
    ${({alignself}) => alignself && css`
        align-self: ${({alignself}) => alignself};
    `}
    ${({lineHeight}) => lineHeight && css`
        line-height: ${({lineHeight}) => lineHeight};
    `}
    cursor: pointer;
    ${({transition}) => transition && css`
        transition: ${({transition}) => transition};
    `}

    text-decoration: none;
    display: ${({display}) => display};
    backface-visibility: hidden;
    margin-right: ${({marginright}) => marginright};
    margin-left: ${({marginleft}) => marginleft};
    margin: ${({margin}) => margin};
    padding: ${({padding}) => padding};
    min-width: ${({minWidth}) => minWidth};
    text-align: center;
    overflow: initial;
    border-radius: ${({borderradius}) => borderradius ? borderradius : "20px"};
    width: ${({widthsmall}) => (widthsmall ? widthsmall : "initial")};
    justify-content: ${({justifycontent}) => justifycontent};
    height: ${({heightsmall}) => heightsmall};

    ${({textTransform}) => textTransform && css`
        text-transform: ${({textTransform}) => textTransform};

        span {
            text-transform: ${({textTransform}) => textTransform};
        }
    `}
    ${media.lessThan(breakpoints.mobile)`
	margin: ${({marginsmall}) => marginsmall};
	${({mobileAlignself}) => mobileAlignself && css`
        align-self: ${({mobileAlignself}) => mobileAlignself};
    `}
`}
    ${media.greaterThan(breakpoints.mobile)`
	  	margin-left: ${({marginleft}) => marginleft};
	`}
    ${media.greaterThan(breakpoints.ipad)`
    width: ${({width}) => (width ? width : "initial")};
  `}
    &:active {
        transform: scale(${({scale}) => scale - 0.01});
    }

    &:focus {
        outline-style: solid;
        outline-offset: 5px;
        outline-width: 2px;
    }

    &:disabled {
        background: ${({disabledcolor}) => disabledcolor};
        cursor: not-allowed;
        opacity: ${({opacity}) => opacity};
    }
`;
const Base = styled.a.attrs(({
                               ariaLabel,
                               display,
                               left,
                               right,
                               nomargin,
                               margin,
                               marginleft,
                               smallmarginleft,
                               smallmargin,
                               padding,
                               smallpadding,
                               wide,
                               type,
                               disabledcolor,
                               scale,
                               fullwidth,
                               heightsmall,
                               width,
                               widthsmall,
                               minHeight,
                               minHeightSmall,
                               border,
                               borderradius,
                               justifycontent,
                               theme,
                               fontWeight,
                               colorhover,
                               alignself,
                             }) => ({
  className: 'base',
  "aria-label": ariaLabel,
  display: display ? display : "flex",
  marginright: left ? "auto" : 0,
  marginleft: marginleft ? marginleft : right ? "auto" : 0,
  smallmarginleft: smallmarginleft ? smallmarginleft : right ? "auto" : 0,
  smallmargin: nomargin ? 0 : smallmargin ? smallmargin : `2rem ${left ? "auto" : 0} 0.5rem ${right ? "auto" : 0}`,
  margin: nomargin ? 0 : margin ? margin : `2rem ${left ? "auto" : 0} 0.5rem ${right ? "auto" : 0}`,
  padding: padding ? padding : wide ? "0.1rem 2rem" : "0.125rem 0",
  smallpadding: smallpadding ? smallpadding : wide ? "0.1rem 2rem" : "0.125rem 0",
  disabledcolor: disabledcolor ? disabledcolor : theme.colors.lightgrey,
  scale: scale ? scale : "1",
  width: fullwidth ? "100%" : wide ? "auto" : width ? width : "180px",
  widthsmall: fullwidth ? "100%" : wide ? "100%" : widthsmall ? widthsmall : "100%",
  heightsmall: heightsmall,
  border: border,
  borderradius: borderradius,
  justifycontent: justifycontent ? justifycontent : "center",
  minheight: minHeight ? minHeight : "",
  minheightsmall: minHeightSmall ? minHeightSmall : "",
  fontWeight: fontWeight ? fontWeight : "normal",
  colorhover: colorhover ? colorhover : undefined,
  alignself: alignself ? alignself : undefined
}))`
    cursor: ${({disabled}) => (disabled ? "not-allowed" : "pointer")};

    span {
        &:hover {
            cursor: ${({disabled}) => (disabled ? "not-allowed" : "")};
        }
    }

    ${({alignself}) => alignself && css`
        align-self: ${({alignself}) => alignself};
    `}
    transition: all 0.2s ease;
    text-decoration: none;
    display: ${({display}) => display};
    align-items: center;
    justify-content: center;
    backface-visibility: hidden;
    margin-right: ${({marginright}) => marginright};
    margin-left: ${({smallmarginleft}) => smallmarginleft};
    padding: ${({padding}) => padding};
    height: ${({height}) => height};
    text-align: center;
    height: ${({height}) => height};
    overflow: initial;
    border-radius: ${({borderradius}) => borderradius ? borderradius : "20px"};
    width: ${({widthsmall}) => (widthsmall ? widthsmall : "100%")};
    justify-content: ${({justifycontent}) => justifycontent};
    margin: ${({smallmargin}) => (smallmargin ? smallmargin : "2rem 0 0 0")};
    min-height: ${({minheightsmall}) => minheightsmall};
    font-weight: ${({fontWeight}) => fontWeight};

    ${media.greaterThan(breakpoints.mobile)`
	min-height: ${({minheight}) => minheight};
		margin: ${({margin}) => margin};
	  	width: ${({width}) => (width ? width : "initial")};
	  	margin-left: ${({marginleft}) => marginleft};
	`}
    ${media.lessThan(breakpoints.mobile)`
	height: ${({heightsmall}) => (heightsmall ? heightsmall : "")};
	min-width: ${({minwidthsmall}) => minwidthsmall};
  width: ${({widthsmall}) => (widthsmall ? widthsmall : "initial")};
  padding: ${({smallpadding}) => smallpadding};
	`}
    &:active {
        transform: scale(${({scale}) => scale - 0.01});
    }

    &:focus {
        outline-style: solid;
        outline-offset: 5px;
        outline-width: 2px;
        outline-color: ${({theme}) => theme.colors.focus};
    }

    &:disabled {
        background: ${({disabledcolor}) => (disabledcolor ? disabledcolor : "")};
        cursor: not-allowed;
    }
`;

export const PrimaryButton = styled(Base).attrs(({
                                                   inverted,
                                                   theme,
                                                   focedBgColor,
                                                   forcedColor,
                                                   padding,
                                                   importandPadding,
                                                   ariaLabel,
                                                 }) => ({
  className: `primaryButton ${inverted ? 'inverted' : ''}`,
  bgColor: focedBgColor ? focedBgColor : inverted ? theme.colors.footerGradient : theme.colors.none,
  bgColorhover: inverted ? theme.colors.none : theme.colors.primary,
  color: forcedColor ? forcedColor : inverted ? theme.colors.white : theme.colors.black,
  colorhover: inverted ? theme.colors.black : theme.colors.white,
  padding: padding ? padding : undefined,
  importandPadding: importandPadding,
  "aria-label": ariaLabel || "primary button",
}))`
    ${({padding, importandPadding}) => padding && css`
        padding: ${({padding}) => padding} ${({importandPadding}) => (importandPadding ? "!important" : "")};
    `}
            /* ${Icon} {
		color: ${({color}) => color}
	} */
    ${SearchWrapper} & {
        margin-left: auto;
    }

    background-color: ${({bgColor}) => bgColor};
    border: 2px solid ${({theme, borderColor}) => borderColor ? borderColor : theme.colors.primary};

    span,
    ${Icon} {
        color: ${({color}) => color};
    }

    &:hover {
        background-color: ${({bgColorhover}) => bgColorhover};
        border-color: ${({bgColorhover}) => bgColorhover};

        span,
        ${Icon} {
            color: ${({colorhover}) => colorhover};
        }
    }
`;
export const ColoredButton = styled(Base).attrs(({
                                                   padding,
                                                   importandPadding,
                                                   colorhover,
                                                   hoverColor,
                                                   zIndex,
                                                   theme,
                                                   inverted
                                                 }) => ({
  className: 'coloredButton',
  padding: padding ? padding : undefined,
  importandPadding: importandPadding,
  colorhover: colorhover ? colorhover : undefined,
  bgColorhover: inverted ? theme.colors.none : hoverColor ?? theme.colors.primary,
}))`
    background-color: ${({bgColor, inverted, theme, padding}) => inverted ? bgColor : theme.colors.none};
    border: ${({bgColor, theme}) => bgColor ? `2px solid ${bgColor}` : `2px solid ${theme.colors.primary}`};

    span {
        color: ${({inverted, theme, color}) => color ? color : inverted ? theme.colors.white : theme.colors.black};
    }

    ${Icon} {
        color: ${({inverted, theme, color}) => color ? color : inverted ? theme.colors.white : theme.colors.black};
    }

    &:hover,
    &:focus {
        background-color: ${({inverted, bgColorhover, theme}) => inverted ? theme.colors.none : bgColorhover};
        border-color: ${({hoverColor, theme}) => hoverColor ?? theme.colors.primary};

        span {
            color: ${({
                          inverted,
                          theme,
                          colorhover
                      }) => colorhover ? colorhover : !inverted ? theme.colors.white : theme.colors.black};
        }

        ${Icon} {
            color: ${({inverted, theme}) => !inverted ? theme.colors.white : theme.colors.black};
        }
    }

    ${({padding, importandPadding}) => padding && css`
        padding: ${({padding}) => padding} ${({importandPadding}) => (importandPadding ? "!important" : "")};
    `}
    ${({zIndex}) => zIndex && css`
        z-index: ${({zIndex}) => zIndex}
    `}
`;
export const Button = styled(Base).attrs(({
                                            inverted,
                                            background,
                                            textHoverColor,
                                            borderColor,
                                            hoverColor,
                                            light,
                                            theme,
                                            textColor,
                                            textColorHover,
                                          }) => ({
  className: `button ${inverted ? 'inverted' : ''}`,
  bgColor: inverted ? (background ? background : "") : theme.colors.none,
  bgColorhover: hoverColor ? hoverColor : !inverted ? background : theme.colors.none,

  color: textColor ? textColor : inverted ? theme.colors.white : theme.colors.black,
  colorhover: textColorHover ? textColorHover : inverted || light ? theme.colors.black : theme.colors.white,
}))`
    background-color: ${({inverted, background, theme}) => inverted ? background : theme.colors.none};
    border: ${({background, borderColor}) => borderColor ? `2px solid ${borderColor}` : `2px solid ${background}`};

    span {
        color: ${({color}) => color};
    }

    &:hover,
    &:focus {
        background-color: ${({bgColorhover}) => bgColorhover};
        border-color: ${({bgColorhover}) => bgColorhover};

        span {
            color: ${({colorhover}) => colorhover};
        }
    }
`;

export const RectangularButton = styled(Base).attrs(({inverted, noBorderHover, noBorderLeftOnHover, theme}) => ({
  bgColor: inverted ? theme.colors.bg1 : theme.colors.primary,
  bgColorhover: inverted ? theme.colors.primary : theme.colors.lightgreen,
  color: inverted ? theme.colors.black : theme.colors.white,
  colorhover: inverted ? theme.colors.white : theme.colors.black,
  heightSmall: inverted ? "40px" : "48px",
  height: inverted ? "50px" : "58px",
  borderHover: noBorderHover ? "none" : `1px solid ${theme.colors.grey}`,
  borderLeftHover: noBorderLeftOnHover ? "none" : `1px solid ${theme.colors.grey}`,
}))`
    background-color: ${({bgColor}) => bgColor};
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${({heightSmall}) => heightSmall};
    border-radius: inherit;

    span {
        color: ${({color}) => color};
    }

    &:hover {
        background-color: ${({bgColorhover}) => bgColorhover};
        border: ${({borderHover}) => borderHover};
        border-left: ${({borderLeftHover}) => borderLeftHover};

        span {
            color: ${({colorhover}) => colorhover};
        }
    }

    ${media.greaterThan(breakpoints.ipad)`
		height: ${({height}) => height};
		width: ${({width}) => (width ? width : "initial")};
  	`}
`;
export const SubmitButton = styled(SubmitBase).attrs(({
                                                        inverted,
                                                        noBorderHover,
                                                        noBorderLeftOnHover,
                                                        theme,
                                                        hoverBorder,
                                                        smallHeight,
                                                        hoverColor,
                                                        border,
                                                      }) => ({
  className: `submitButton ${inverted ? 'inverted' : ''}`,
  bgColor: inverted ? theme.colors.lightgreen : theme.colors.primary,
  bgColorhover: hoverColor ? hoverColor : inverted ? theme.colors.primary : theme.colors.lightgreen,
  color: inverted ? theme.colors.black : theme.colors.white,
  colorhover: inverted ? theme.colors.white : theme.colors.black,
  heightSmall: smallHeight ? smallHeight : inverted ? "40px" : "48px",
  height: inverted ? "50px" : "48px",
  border: border ? border : "",
  borderHover: hoverBorder ? hoverBorder : noBorderHover ? "none" : `1px solid ${theme.colors.grey}`,
  borderLeftHover: hoverBorder ? hoverBorder : noBorderLeftOnHover ? "none" : `1px solid ${theme.colors.grey}`,
}))`
    background-color: ${({bgColor}) => bgColor};
    border: ${({border}) => (border ? border : "none")};
    height: ${({heightsmall}) => heightsmall};
    border-radius: ${({borderRadius}) => borderRadius ? borderRadius : "inherit"};

    ${SearchWrapper} & {
        border-radius: ${({theme}) => `0 ${theme.border.radius} ${theme.border.radius} 0`};
    }

    span {
        color: ${({color}) => color};
    }

    &:hover {
        background-color: ${({theme, hoverColor}) => hoverColor ? hoverColor : theme.colors.bg1};
        border: ${({borderHover}) => borderHover};
        border-left: ${({borderLeftHover}) => borderLeftHover};

        span {
            color: ${({colorhover}) => colorhover};
        }
    }

    ${media.greaterThan(breakpoints.ipad)`
		height: ${({height}) => height};
		width: ${({width}) => (width ? width : "initial")};
  	`}
`;

export const RoundedSubmitButton = styled(SubmitButton)`
    position: absolute;
    right: 0;
    top: 0;
    margin: 0;
    border: ${({border}) => (border ? border : "")};
    height: 100%;
    width: auto;
    min-width: 5rem;
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;

    &:hover {
        background-color: ${({theme}) => theme.colors.bg1};

        span {
            color: ${({theme, hoverColor}) => hoverColor ? hoverColor : theme.colors.black};
        }

        /* border: 1px solid #8f8f8f; */
        border: ${({border}) => (border ? border : "")};
    }

    ${media.greaterThan(breakpoints.ipad)`
		width: auto;
		height: 100%;
  `}
`;
export const HeaderButton = styled.button.attrs(({ariaLabel}) => ({
  "aria-expanded": "false", "aria-label": ariaLabel || "header button",
}))`
    border: none;
    background: transparent;
`;

export const PrimarySubmitButton = styled(SubmitBase).attrs(({inverted, theme, focedBgColor, forcedColor}) => ({
  className: `primarySubmitButton ${inverted ? 'inverted' : ''}`,
  bgColor: focedBgColor ? focedBgColor : inverted ? theme.colors.primary : theme.colors.none,
  bgColorhover: inverted ? theme.colors.none : theme.colors.primary,
  color: forcedColor ? forcedColor : inverted ? theme.colors.white : theme.colors.black,
  colorhover: inverted ? theme.colors.black : theme.colors.white,
}))`
    background-color: ${({bgColor}) => bgColor};
    border: 2px solid ${({theme}) => theme.colors.primary};

    span {
        color: ${({color}) => color};
    }

    &:hover {
        background-color: ${({bgColorhover}) => bgColorhover};
        border-color: ${({bgColorhover}) => bgColorhover};

        span {
            color: ${({colorhover}) => colorhover};
        }
    }
`;

export const CarouselControl = styled.button.attrs(({ariaLabel}) => ({
  className: 'carouselControl', "aria-label": ariaLabel || "carousel button",
}))`
    width: 46px;
    height: 46px;
    border: 1px solid ${({isDisabled}) => isDisabled ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,1)'};
    border-radius: 50%;
    background-color: transparent;
    cursor: pointer;
    transition: 0.5s;

    &:focus {
        outline: none;
    }

    &:hover {
        border: 1px solid ${({theme, isDisabled}) => isDisabled ? 'rgba(0,0,0,0.3)' : theme.colors.btnprimary};

        i {
            color: ${({theme, isDisabled}) => isDisabled ? 'rgba(0,0,0,0.3)' : theme.colors.btnprimary};
        }
    }

    i {
        font-size: 20px;
        color: ${({isDisabled}) => isDisabled ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,1)'};
        transition: 0.5s;
    }
`
